import { Code, Loader, Modal, Stack, Text } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { AdminBackgroundProcessDetail } from './types';

type BackgroundProcessDetailModalProps = {
  processId: string | null;
  companyId: string;
  onClose: () => void;
};

function MetadataRow({ label, value }: { label: string; value: string | null | undefined }) {
  const displayValue = value === null || value === undefined ? '-' : value;
  return (
    <Text size="sm" style={{ fontFamily: 'monospace' }}>
      <Text span fw={600}>
        {label}:
      </Text>{' '}
      {displayValue}
    </Text>
  );
}

export function BackgroundProcessDetailModal({
  processId,
  companyId,
  onClose,
}: BackgroundProcessDetailModalProps) {
  const { data, isLoading } = useQuery<AdminBackgroundProcessDetail>({
    queryKey: ['admin', 'companies', companyId, 'background-processes', processId],
    enabled: !!processId,
  });

  const process = data;

  return (
    <Modal
      opened={!!processId}
      onClose={onClose}
      title={`Background process: ${process?.processName ?? ''}`}
      size={800}
    >
      {isLoading ? (
        <Loader />
      ) : (
        <Stack gap="md">
          <Stack gap="xs">
            <MetadataRow label="ID" value={process?.id} />
            <MetadataRow label="Process name" value={process?.processName} />
            <MetadataRow label="Status" value={process?.status} />
            <MetadataRow label="Status message" value={process?.statusMessage} />
            <MetadataRow
              label="Created"
              value={process ? new Date(process.createdAt).toLocaleString() : undefined}
            />
            <MetadataRow
              label="Updated"
              value={process ? new Date(process.updatedAt).toLocaleString() : undefined}
            />
          </Stack>

          {process?.extraDetails && (
            <Stack gap="xs">
              <Text size="sm" fw={600}>
                Extra details:
              </Text>
              <Code block style={{ maxHeight: '50vh', maxWidth: '100%', overflow: 'auto' }}>
                {JSON.stringify(process.extraDetails, null, 2)}
              </Code>
            </Stack>
          )}
        </Stack>
      )}
    </Modal>
  );
}
